<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useDebugStore } from '@/stores/settings/debug'

const { debugSlideLayout } = storeToRefs(useDebugStore())
</script>

<template>
  <div :class="{ 'debug-slidelayout': debugSlideLayout }">
    <slot></slot>
  </div>
</template>
